<template>
  <div>
    <template v-if="!isGenerating">
      <b-row  style="margin-top: 15px;">
        <b-col>
          <p>
            TOPIC: <strong>{{ subject }}</strong>
          </p>
          <p>-
            <date-format-toggle
                :date="createdAt"
            />
          </p>
        </b-col>
        <b-col>
          <b-button-toolbar key-nav aria-label="Toolbar with button groups">
            <b-button-group
                class="mx-1">
              <b-button
                  style="float: left; background-color:#0fb6fe"
                  :disabled="idx <= 0"
                  @click="handlePageTo(idx - 1)"
              >&lsaquo;</b-button>
            </b-button-group>
            <b-button-group class="mx-1">
              {{idx + 1 }} of  {{maxWords}}
            </b-button-group>
            <b-button-group
                class="mx-1">
              <b-button
                  style="float: right; background-color:#0fb6fe"
                  :disabled="idx == maxWords - 1"
                  @click="handlePageTo(idx + 1)"
              >
                &rsaquo;
              </b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
      <div>
        <div v-if="typeof output === 'object'">
          <pane-response-poll
              style="margin-top: 15px"
              v-for="(aPoll, p) in polls"
              :poll="aPoll"
              :key="`poll-${p}`"
          />
        </div>
        <div v-else>
          {{output}}
        </div>
      </div>
      <pane-response-feedback
          style="margin-top: 15px"
          :curr-doc="currDoc"
          :path="path"
          :profile="profile"
      />
    </template>
    <template v-else>
      <b-skeleton animation="throb" width="85%"></b-skeleton>
      <b-skeleton animation="throb" width="55%"></b-skeleton>
      <b-skeleton animation="throb" width="70%"></b-skeleton>
    </template>
  </div>
</template>

<script>
import PaneResponseFeedback from "./paneResponseFeedback";
import PaneResponsePoll from "./paneResponsePoll";
import DateFormatToggle from "@/components/common/dateFormatToggle";
export default {
  name: "Display_PaneResponse",
  components: {
    PaneResponsePoll,
    DateFormatToggle,
    PaneResponseFeedback
  },
  created(){},
  mounted() {},
  props: {
    currDoc: {
      type: Object,
      required: false,
      default: ()=>{return {}}
    },
    path: {
      type: String,
      required: false,
      default: ''
    },
    profile: {
      type: Object,
      required: false,
      default: () => {}
    },
    idx: {
      type: Number,
      required: false,
      default: 0
    },
    maxWords: {
      type: Number,
      required: true,
      default: 0
    },
    isGenerating: {
      type: Boolean,
      required: true,
      default: false
    },
    output: {
      type: [Object, String],
      required: false,
      default: () => {}
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    settings: {
      type: Object,
      required: false,
      default: () => {}
    },
    userData: {
      type: Object,
      required: false,
      default: () => {}
    },
    isManagementMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subject(){
      return this.currDoc && this.currDoc.subject ? this.currDoc.subject : null;
    },
    polls(){
      return this.output && this.output.polls &&
      Array.isArray(this.output.polls)
          ? this.output.polls : [];
    },
    createdAt(){
      return this.currDoc && this.currDoc._created_at ? this.currDoc._created_at : null;
    }
  },
  methods: {
    handlePageTo(pageNumber){
      this.$emit('page-to', pageNumber)
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
</style>
